import React, { useEffect, useState } from 'react';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function VideoGeneration() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [currentStep, setCurrentStep] = useState('Initializing...');
  useEffect(() => {
    const steps = [{
      label: 'Analyzing image composition...',
      duration: 1000
    }, {
      label: 'Generating motion paths...',
      duration: 1200
    }, {
      label: 'Applying animation effects...',
      duration: 1000
    }, {
      label: 'Adding text overlays...',
      duration: 800
    }, {
      label: 'Rendering final video...',
      duration: 1500
    }];
    let currentProgress = 0;
    let stepIndex = 0;
    const interval = setInterval(() => {
      if (stepIndex < steps.length) {
        setCurrentStep(steps[stepIndex].label);
        const increment = 100 / steps.length;
        currentProgress += increment;
        setProgress(Math.min(currentProgress, 100));
        stepIndex++;
      } else {
        clearInterval(interval);
        setIsComplete(true);
      }
    }, 1200);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1908">
      <Sidebar data-id="element-1909" />
      <main className="flex-1" data-id="element-1910">
        <Header data-id="element-1911" />
        <div className="px-6 py-8" data-id="element-1912">
          <div className="max-w-4xl mx-auto" data-id="element-1913">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1914">
              Generating Video
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1915">
              AI is creating your professional video ad
            </p>

            {!isComplete ? <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-1916">
                <div className="text-center mb-8" data-id="element-1917">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1918">
                    <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" data-id="element-1919"></div>
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-1920">
                    {currentStep}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1921">
                    This may take 1-2 minutes...
                  </p>
                </div>

                <div className="mb-4" data-id="element-1922">
                  <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-1923">
                    <span data-id="element-1924">Progress</span>
                    <span data-id="element-1925">{Math.round(progress)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-1926">
                    <div className="bg-green-500 h-3 rounded-full transition-all duration-500" style={{
                  width: `${progress}%`
                }} data-id="element-1927"></div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-6" data-id="element-1928">
                  <h4 className="font-medium text-green-900 mb-2" data-id="element-1929">
                    What's Happening?
                  </h4>
                  <ul className="text-sm text-green-800 space-y-1" data-id="element-1930">
                    <li data-id="element-1931">• Analyzing image for optimal motion paths</li>
                    <li data-id="element-1932">• Applying selected animation style</li>
                    <li data-id="element-1933">• Adding text overlays with smooth transitions</li>
                    <li data-id="element-1934">• Rendering high-quality video output</li>
                  </ul>
                </div>
              </div> : <div className="space-y-6" data-id="element-1935">
                <div className="bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-1936">
                  <div className="flex items-center" data-id="element-1937">
                    <CheckCircleIcon className="text-green-500 mr-3 flex-shrink-0" size={32} data-id="element-1938" />
                    <div data-id="element-1939">
                      <h3 className="text-lg font-medium text-green-900" data-id="element-1940">
                        Video Generated Successfully!
                      </h3>
                      <p className="text-sm text-green-700" data-id="element-1941">
                        Your professional video ad is ready to preview
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1942">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1943">
                    Video Details
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1944">
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1945">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1946">Duration</p>
                      <p className="font-semibold text-gray-800" data-id="element-1947">6 seconds</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1948">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1949">Resolution</p>
                      <p className="font-semibold text-gray-800" data-id="element-1950">
                        1080 x 1080 px
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1951">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1952">Format</p>
                      <p className="font-semibold text-gray-800" data-id="element-1953">MP4 (H.264)</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1954">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1955">File Size</p>
                      <p className="font-semibold text-gray-800" data-id="element-1956">~3.5 MB</p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between" data-id="element-1957">
                  <button onClick={() => navigate('/dealer/video-generator/configure')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1958">
                    Back to Edit
                  </button>
                  <button onClick={() => navigate('/dealer/video-generator/preview')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1959">
                    Preview & Download
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}